import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import TopNavbar from "./TopNavbar";
import Navbar from "./Navbar";
import ActionHeader from "./ActionHeader";
import Footer from "../../pages/footer/footer";

const Layout = () => {
  const [hideHeaders, setHideHeaders] = useState(false);

  useEffect(() => {
    const handleSkip = () => setHideHeaders(true);
    const handleScroll = () => {
      if (window.scrollY === 0) setHideHeaders(false);
    };

    window.addEventListener("skip-main-content", handleSkip);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("skip-main-content", handleSkip);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Calculate header heights based on screen size
  const getHeaderHeight = () => {
    if (hideHeaders) return 20;
    // TopNavbar (48px) + Navbar (varies) + ActionHeader (48px)
    return {
      xs: 48 + 56 + 48, // mobile
      sm: 48 + 64 + 48, // tablet
      md: 48 + 90 + 48, // desktop
    };
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* FIXED HEADERS */}
      {!hideHeaders && (
        <Box sx={{
          position: "fixed", top: 0,left: 0,right: 0, width: "100%", zIndex: 1200 }}>
      <TopNavbar />
      <Navbar />
      <ActionHeader />
    </Box>
  )
}

{/* Responsive Spacer */ }
<Box
  sx={{
    height: hideHeaders
      ? 20
      : {
        xs: 152, // 48+56+48
        sm: 160, // 48+64+48
        md: 186, // 48+90+48
      },
  }}
/>

{/* MAIN CONTENT */ }
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>

      <Footer />
    </Box >
  );
};

export default Layout;


// import { Box } from "@mui/material";
// import { Outlet } from "react-router-dom";
// import { useEffect, useState } from "react";
// import TopNavbar from "./TopNavbar";
// import Navbar from "./Navbar";
// import ActionHeader from "./ActionHeader";
// import Footer from "../../pages/footer/footer";

// const Layout = () => {
//   const [hideHeaders, setHideHeaders] = useState(false);

//   useEffect(() => {
//     const handleSkip = () => setHideHeaders(true); // hide on skip
//     const handleScroll = () => {
//       if (window.scrollY === 0) setHideHeaders(false); // show again at top
//     };

//     window.addEventListener("skip-main-content", handleSkip);
//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("skip-main-content", handleSkip);
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//       {/* FIXED HEADERS */}
//       {!hideHeaders && (
//         <Box sx={{ position: "fixed", top: 0, width: "100%", zIndex: 1200 }}>
//           <TopNavbar />
//           <Navbar />
//           <ActionHeader />
//         </Box>
//       )}

//       {/* Spacer */}
//       <Box sx={{ height: hideHeaders ? 20 : 170 }} />

//       {/* MAIN CONTENT */}
//       <Box component="main" sx={{ flex: 1 }}>
//         <Outlet />
//       </Box>

//       <Footer />
//     </Box>
//   );
// };

// export default Layout;
